const extensions = ["jpg", "png", "jpeg"];
const totalImages = 161;
const galleryData = [];

for (let i = 1; i <= totalImages; i++) {
  let found = false;

  for (const ext of extensions) {
    const imgPath = `/images/gallery/gallery${i}.${ext}`;
    const img = new Image();
    img.src = imgPath;

    img.onload = () => {
      if (!found) {
        galleryData.push({ img: imgPath });
        found = true;
      }
    };
  }
}

export default galleryData;
